import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import { LocationContextPropType } from '../../../services/LocationContext';
import GenericMeta from '../GenericMeta';

const SEOLink = ({ rel, path, addOpenGraphTag, locationContext, hreflang }) => {
  const isFullUrl = path.includes('://');
  const url = isFullUrl
    ? path
    : `${locationContext.protocol}//${locationContext.host}${path}`;

  const getLink = () => {
    // https://github.com/nfl/react-helmet/issues/279#issuecomment-651615114

    return hreflang === 'x-default' ? (
      <link hrefLang={hreflang} href={url} rel={rel} />
    ) : (
      <link rel={rel} href={url} hrefLang={hreflang} />
    );
  };

  const link = hreflang ? getLink() : <link rel={rel} href={url} />;

  return (
    <>
      {addOpenGraphTag && (
        <>
          <GenericMeta name="twitter:url" content={url} />
          <GenericMeta property="og:url" content={url} />
        </>
      )}
      <Helmet>{link}</Helmet>
    </>
  );
};

SEOLink.propTypes = {
  rel: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  locationContext: LocationContextPropType.isRequired,
  hreflang: PropTypes.string,
  addOpenGraphTag: PropTypes.bool,
};
export default inject('locationContext')(observer(SEOLink));
